export default {
  scope: ({ path }) => path.includes('spray-foam'),
  colors: { brand: '#33642A' }
};
